/**
 * Imágenes del Pórtico — ÚNICA fuente (GEN-11, decisión de producto de Guo
 * 2026-07-17): TODAS las imágenes (foto de ficha, icono de agente y logo del
 * tenant) las resuelve el FRONT por `id`, con el mismo patrón que los colores
 * (agent-colors.js): resolución data-driven en el cliente, cero ramas por
 * tenant y cero código por agente.
 *
 * Convención de assets (public/):
 *   - Agente: /avatars/<agent-id>.jpg   (retrato ~3:4, «foto extendida»;
 *     la ficha y el icono circular recortan el MISMO fichero)
 *   - Tenant: /logos/<tenant-id>.svg  y  /logos/<tenant-id>-dark.svg
 *
 * El kernel NO emite URLs de imagen: aunque el descriptor trajera
 * `avatar_url`/`logo_url`, aquí se IGNORAN (se retiró la prioridad que tenía
 * el dato del kernel). Dar de alta un agente o tenant nuevo = soltar su
 * fichero con el nombre del id, sin tocar código; si el fichero no existe,
 * la UI cae a la inicial de siempre (AgentAvatar / TenantLogo) sin romper
 * el layout.
 */

// Foto de un agente por id. Sin id no hay foto -> null (iniciales).
export function avatarUrlOf(agent) {
  const id = agent?.id
  return id ? `/avatars/${encodeURIComponent(id)}.jpg` : null
}

// Logo del tenant por id y tema — espejo de agentColorOf(palette, id, theme):
// la variante -dark existe porque una tinta oscura desaparece sobre el tema
// oscuro. Sin tenant -> null (insignia con la inicial).
export function tenantLogoOf(tenant, theme /* 'light'|'dark' */) {
  const id = tenant?.id
  if (!id) return null
  return `/logos/${encodeURIComponent(id)}${theme === 'dark' ? '-dark' : ''}.svg`
}
